export default function validateEmail(email) {
  let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/validateEmail', validateEmail);